import React from "react";
import { Box, Chip, Grid, IconButton, Typography } from "@mui/material";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function FoodHabit() {
  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "Dessert",
      width: 150,
    },
    { field: "vDate", headerName: "Calories", width: 150 },
    { field: "patientName", headerName: "Fat (g)", width: 207 },
    { field: "problemName", headerName: "Protein (g)", width: 250 },
  ];

  const rows = [
    {
      id: 1,
      vDate: 25,
      patientName: 20,
      problemName: 50,
    },
    {
      id: 2,
      vDate: 10,
      patientName: 80,
      problemName: 60,
    },
  ];

  return (
    <Box>
      <Grid container direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
        <Grid item>
          <Typography variant="h5">Review food habits By Dietitian</Typography>
        </Grid>
        <Grid item>
          <Chip label="Active" color="primary" variant="outlined" size="small" />
        </Grid>
        <Grid item>
          <IconButton aria-label="refresh">
            <RefreshIcon />
          </IconButton>
        </Grid>
      </Grid>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        hideFooter
        hideFooterPagination
        disableSelectionOnClick
        experimentalFeatures={{ newEditingApi: true }}
        autoHeight
        components={{ Toolbar: GridToolbar }}
        componentsProps={{
          toolbar: {
            csvOptions: { disableToolbarButton: true },
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 250 },
          },
        }}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
      />
    </Box>
  );
}
